import { render, staticRenderFns } from "./ResidualValuesDetail.vue?vue&type=template&id=e9a8360a&scoped=true"
import script from "./ResidualValuesDetail.vue?vue&type=script&lang=js"
export * from "./ResidualValuesDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a8360a",
  null
  
)

export default component.exports